module.exports = __webpack_public_path__ + "static/media/emma_vp_pechory.cbf8e5f8.jpg";